// mulberry32 — small fast seedable RNG. Shared by world seeding and the
// dungeon generator; every stage that needs determinism derives its own
// stream from a base seed (see src/game/dungeon/).

export function mulberry32(seed: number): () => number {
  let t = seed >>> 0
  return function () {
    t = (t + 0x6d2b79f5) >>> 0
    let r = t
    r = Math.imul(r ^ (r >>> 15), r | 1)
    r ^= r + Math.imul(r ^ (r >>> 7), r | 61)
    return ((r ^ (r >>> 14)) >>> 0) / 4294967296
  }
}

/** Random element of a non-empty array. */
export function pickFrom<T>(rng: () => number, arr: readonly T[]): T {
  return arr[Math.floor(rng() * arr.length)]
}

/** Random integer in [lo, hi] inclusive. */
export function intIn(rng: () => number, lo: number, hi: number): number {
  return lo + Math.floor(rng() * (hi - lo + 1))
}

/** Random float in [lo, hi). */
export function floatIn(rng: () => number, lo: number, hi: number): number {
  return lo + rng() * (hi - lo)
}
